import {Button} from '@chakra-ui/react';
import React from 'react';
import {ItemCatalogue2StateFF} from 'ff-common';
import NiceModal from '@ebay/nice-modal-react';
import {ModalSelectList} from '@/domains/liste/components/ModalSelectList';
import {ListIcon} from '@/components/svg/ListIcon';

export const AjoutListeBouton: React.FC<{itemState: ItemCatalogue2StateFF}> = ({
  itemState,
}) => {
  return (
    <Button
      bg='gray.light'
      width='35px'
      height='35px'
      _hover={{bg: 'gray.100'}}
      onClick={() => {
        NiceModal.show(ModalSelectList, {itemState});
      }}
    >
      <ListIcon color='gray.dark' />
    </Button>
  );
};
